import { AudioInputSettings } from '../UserContext'
import { copyObjectByKeyOnto } from '../utils'
import ElectronIPC from './ElectronIPC'
import { env } from './EnvironmentVariables'
import i18n from 'i18next'
import { AudioEngineRelayServer } from '../core/AudioEngine'

// Hardcoded constants
export const app_kind_desktop = 'muse-app:desktop'
export const app_kind_web = 'muse-app:web'
export const title_bar_color = '#2d2e2f'
export const choose_initial_mode_page_window_dim = { width: 1142, height: 812 }
export const session_settings_page_window_dim = { width: 880, height: 800 }
export const collaborate_page_retracted_max_width = 500
export const collaborate_page_retracted_default_width = 330
export const collaborate_page_full_retracted_default_dim = { width: 45, height: 465 }
export const collaborate_page_normal_min_width = 600
export const collaborate_page_normal_default_width = 1280
export const ws_call_timeout_ms = 15000
export const spinner_width_md = 22
export const max_videos_per_page = 16
export const default_tooltip_enter_delay = 500
export const terms_and_conditions_link = 'https://musesessions.co/terms'
export const privacy_policy_link = 'https://musesessions.co/privacy'
export const large_screenshare_warning_width_threshold = 2048
export const sidebar_width_threshold = 550
export const media_recorder_audio_bitrate = 192000
export const euCountryCodes = [
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE' /*'KR'*/,
]
export const availableLanguages = ['en', 'es', 'pt', 'ko', 'ja', 'hi', 'de', 'fr', 'it', 'ru']
export const supported_browsers = ['chrome', 'safari', 'edge', 'ios', 'crios', 'firefox', 'edge', 'opera', 'instagram']
export const commonSampleRates = [8_000, 11_025, 16_000, 22_050, 44_100, 48_000, 88_200, 96_000, 176_400, 192_000]
export const commonBitDepths = [16, 24, 32]
export const defaultAudioInputSettings = {
    sampleRate: 44100,
    bitDepth: 16,
    channelCount: 2,
    channelSelection: [],
    bufferSizeMs: 100,
}
export const defaultAudioOutputSettings = {
    sampleRate: 44100,
    bitDepth: 16,
    channelCount: 2,
    channelSelection: [],
    bufferSizeMs: 100,
}
export const default_sfu_audio_bitrate = 192000
export const availableCompressionBitrates = [96000, 128000, 192000, 256000, 320000, 510000]
export const availableBufferSizeMs = [0, 10, 50, 100, 250, 500, 750, 1000, 1500, 2000, 2500]
export const proPolicies = ['pro', 'pro-lifetime-202404', 'admin']
export const max_simultaneous_chatbox_files_ct = 5

// set in `loadFromEnv()`
export const defaultDirectories = {
    home: '',
    downloads: '',
    documents: '',
    remote_recording: '',
    screen_recording: '',
}
export const video_width_presets = [1280, 1080, 720, 640, 480, 360, 240, 120]
export const system_audio_device_mapping = [
    {
        id: 'vb_audio_cable_line1',
        inputDeviceLabel: 'Line 1 (Virtual Audio Cable)',
        outputDeviceLabel: 'Line 1 (Virtual Audio Cable)',
    },
    {
        id: 'vb_audio_cable',
        inputDeviceLabel: 'CABLE Input (VB-Audio Virtual Cable)',
        outputDeviceLabel: 'CABLE Output (VB-Audio Virtual Cable)',
    },
    {
        id: 'vb_audio_cable_a',
        inputDeviceLabel: 'CABLE-A Input (VB-Audio Cable A)',
        outputDeviceLabel: 'CABLE-A Output (VB-Audio Cable A)',
    },
    {
        id: 'vb_audio_cable_b',
        inputDeviceLabel: 'CABLE-B Input (VB-Audio Cable B)',
        outputDeviceLabel: 'CABLE-B Output (VB-Audio Cable B)',
    },
    {
        id: 'vb_audio_cable_c',
        inputDeviceLabel: 'CABLE-C Input (VB-Audio Cable C)',
        outputDeviceLabel: 'CABLE-C Output (VB-Audio Cable C)',
    },
    {
        id: 'vb_audio_cable_d',
        inputDeviceLabel: 'CABLE-D Input (VB-Audio Cable D)',
        outputDeviceLabel: 'CABLE-D Output (VB-Audio Cable D)',
    },
    {
        id: 'voicemeeter_1',
        inputDeviceLabel: 'VoiceMeeter Input (VB-Audio VoiceMeeter VAIO)',
        outputDeviceLabel: 'VoiceMeeter Output (VB-Audio VoiceMeeter VAIO)',
    },
    {
        id: 'voicemeeter_2',
        inputDeviceLabel: 'Voicemeeter Input (VB-Audio Voicemeeter VAIO)',
        outputDeviceLabel: 'Voicemeeter Out B1 (VB-Audio Voicemeeter VAIO)',
    },
    {
        id: 'voicemeeter_3',
        inputDeviceLabel: 'Voicemeeter Input (VB-Audio Voicemeeter VAIO)',
        outputDeviceLabel: 'Voicemeeter Out B2 (VB-Audio Voicemeeter VAIO)',
    },
    {
        id: 'voicemeeter_4',
        inputDeviceLabel: 'Voicemeeter Input (VB-Audio Voicemeeter VAIO)',
        outputDeviceLabel: 'Voicemeeter Out B3 (VB-Audio Voicemeeter VAIO)',
    },
    {
        id: 'hifi_cable',
        inputDeviceLabel: 'Hi-Fi Cable Input (VB-Audio Hi-Fi Cable)',
        outputDeviceLabel: 'Hi-Fi Cable Output (VB-Audio Hi-Fi Cable)',
    },
]
export const desktopVideoHeightOptions = [2160, 1440, 1260, 1080, 900, 720, 600, 480, 360]
export const screen_share_resolution_warning_threshold = 720 /* 720p */
export const video_preview_show_timeout_ms = 8000
export const desktop_source_thumbnail_size = { width: 600, height: 600 }
export const clientKind = 'electron-app'
export const appNotificationChimeSrc = 'https://musecdn.sfo3.digitaloceanspaces.com/chime.wav'
export const screenControlDebounceMs = 60
export const max_guest_name_length = 50
export type AudioQualityPresetCode =
    | 'voice'
    | 'enhanced'
    | 'pro_essential'
    | 'pro_enhanced'
    | 'pro_hd'
    | 'pro_cd'
    | 'pro_studio'
    | 'pro_highest'
export type AudioQualityPreset = {
    code: AudioQualityPresetCode
    title: string
    menuItemLabel: string
    isWebRtc: boolean
    isPro: boolean
    isProCompressed: boolean
    isVoice: boolean
    supportedFeatures: { avSync: boolean; echoCancellation: boolean; variableQuality: boolean }
    description: string
}
export function getAudioQualityPresets(): AudioQualityPreset[] {
    const { t } = i18n

    return [
        {
            code: 'voice',
            title: t('Voice Call'),
            menuItemLabel: t('Voice Call - Good for voice calls'),
            isWebRtc: true,
            isPro: false,
            isProCompressed: false,
            isVoice: true,
            supportedFeatures: { avSync: true, echoCancellation: true, variableQuality: true },
            description: t('OPUS 96 kbps. Variable quality depends on network conditions. Includes echo cancellation.'),
        },
        {
            code: 'enhanced',
            title: t('OPUS 192 kbps (variable)'),
            menuItemLabel: t('High Quality - OPUS 192 kbps (variable)'),
            isWebRtc: true,
            isPro: false,
            isProCompressed: false,
            isVoice: false,
            supportedFeatures: { avSync: true, echoCancellation: false, variableQuality: true },
            description: t('OPUS 192 kbps. Variable quality depends on network conditions. No echo cancellation.'),
        },
        {
            code: 'pro_essential',
            title: 'OPUS 96 kbps',
            menuItemLabel: t('Low Quality - OPUS 96 kbps'),
            isWebRtc: false,
            isPro: true,
            isProCompressed: true,
            isVoice: false,
            supportedFeatures: { avSync: false, echoCancellation: false, variableQuality: false },
            description: t('OPUS 96 kbps. No echo cancellation. Buffer may affect synchronization with video.'),
        },
        {
            code: 'pro_enhanced',
            title: 'OPUS 192 kbps',
            menuItemLabel: t('High Quality - OPUS 192 kbps'),
            isWebRtc: false,
            isPro: true,
            isProCompressed: true,
            isVoice: false,
            supportedFeatures: { avSync: false, echoCancellation: false, variableQuality: false },
            description: t('OPUS 192 kbps. No echo cancellation. Buffer may affect synchronization with video.'),
        },
        {
            code: 'pro_hd',
            title: 'OPUS 256 kbps',
            menuItemLabel: t('Highest Quality - OPUS 256 kbps'),
            isWebRtc: false,
            isPro: true,
            isProCompressed: true,
            isVoice: false,
            supportedFeatures: { avSync: false, echoCancellation: false, variableQuality: false },
            description: t('OPUS 256 kbps. No echo cancellation. Buffer may affect synchronization with video.'),
        },
        {
            code: 'pro_cd',
            title: 'PCM 16 bit',
            menuItemLabel: t('High Quality - PCM 16 bit'),
            isWebRtc: false,
            isPro: true,
            isProCompressed: false,
            isVoice: false,
            supportedFeatures: { avSync: false, echoCancellation: false, variableQuality: false },
            description: t(
                'PCM 16-bit uncompressed. No echo cancellation. Buffer may affect synchronization with video.'
            ),
        },
        {
            code: 'pro_studio',
            title: 'PCM 24 bit',
            menuItemLabel: t('Higher Quality - PCM 24 bit'),
            isWebRtc: false,
            isPro: true,
            isProCompressed: false,
            isVoice: false,
            supportedFeatures: { avSync: false, echoCancellation: false, variableQuality: false },
            description: t(
                'PCM 24-bit uncompressed. No echo cancellation. Buffer may affect synchronization with video.'
            ),
        },
        {
            code: 'pro_highest',
            title: 'PCM 32 bit',
            menuItemLabel: t('Best Quality - PCM 32 bit'),
            isWebRtc: false,
            isPro: true,
            isProCompressed: false,
            isVoice: false,
            supportedFeatures: { avSync: false, echoCancellation: false, variableQuality: false },
            description: t(
                'PCM 32-bit uncompressed. No echo cancellation. Buffer may affect synchronization with video.'
            ),
        },
    ]
}
export function supportedFeaturesExplanation(code: 'avSync' | 'echoCancellation' | 'variableQuality', state: boolean) {
    const { t } = i18n

    switch (code) {
        case 'avSync':
            if (state) {
                return t('The audio will be synchronized with the video.')
            } else {
                return t('Audio/video sync is off because you set a constant audio buffer size.')
            }
        case 'echoCancellation':
            if (state) {
                return t('Echo cancellation is enabled for voice call level quality.')
            } else {
                return t('Echo cancellation is off because it is only supported for voice call level quality.')
            }
        case 'variableQuality':
            if (state) {
                return t('The audio quality dynamically adjusts depending on the network condition.')
            } else {
                return t('The audio quality will strictly follow your buffer and quality settings.')
            }
    }
    return null
}
export const settingsToAudioQualityPesetCode = (settings: AudioInputSettings): AudioQualityPresetCode => {
    const s = settings
    if (s.isAudioEngine) {
        if (s.isCompressed) {
            // choose btwn pro_standard, pro_enhanced, pro_hd, and pro_cd
            // based on compressionBitrate.
            if (s.compressionBitrate <= 96_000) {
                return 'pro_essential'
            } else if (s.compressionBitrate <= 192_000) {
                return 'pro_enhanced'
            } else if (s.compressionBitrate <= 256_000) {
                return 'pro_hd'
            } else {
                return 'pro_hd'
            }
        } else {
            // choose btwn pro_cd, pro_studio, and pro_highest based on bitDepth.
            if (s.bitDepth === 16) {
                return 'pro_cd'
            } else if (s.bitDepth === 24) {
                return 'pro_studio'
            } else {
                return 'pro_highest'
            }
        }
    } else {
        if (!s.isHighQuality) {
            return 'voice'
        } else {
            return 'enhanced'
        }
    }
}
export const max_channels_per_device = 8

// Dynamically loaded constants
export let api_base_path = ''
export let wss_base_path = ''
export let has_custom_title_bar = false
export let title_bar_height = '0px'
export let title_bar_height_px = 0
export let appversion = ''
export let cpu_arch = ''

// Various keys
export const notifications_suppress_remote_recording_learn_more = 'notifications_suppress_remote_recording_learn_more'
export const notifications_suppress_midi_learn_more = 'notifications_suppress_midi_learn_more'
export const notifications_suppress_sessionrecording_learn_more = 'notifications_suppress_sessionrecording_learn_more'
export const notifications_suppress_first_time_app_notice = 'notifications_suppress_first_time_app_notice'
export const appstart_notifications_suppress_id = 'appstart_notifications_suppress_id'
export const notifications_suppress_midi_off_notice = 'notifications_suppress_midi_off_notice'
export const media_selection_prev_preference = 'media_selection_prev_preference'
export const keyboardshortcut_talkback = 'keyboardshortcut_talkback'
export const filespaceusage_cache = 'filespaceusage_cache'
export const show_welcome_page = 'show_welcome_page'
export const is_first_time_app_render = 'is_first_time_app_render'
export const suppress_collaborate_page_quick_setup_guide = 'suppress_collaborate_page_quick_setup_guide'
export const win32_muse_midi_output_device_label = 'Muse MIDI Receive'
export const win32_muse_midi_passthrough_device_label = 'Muse MIDI Passthrough'
export const LocalStorageKey = {}

// This function must be called after env.load() has been called.
export function loadFromEnv(env: any) {
    has_custom_title_bar = env.OS === 'win32' && env.IS_ELECTRON
    title_bar_height = has_custom_title_bar ? '30px' : '0px'
    title_bar_height_px = has_custom_title_bar ? 30 : 0
    appversion = env.APP_VERSION

    api_base_path = env.API_BASE_PATH
    wss_base_path = env.WSS_BASE_PATH

    loadDefaultDirectories()
}

async function loadDefaultDirectories() {
    defaultDirectories.home = await ElectronIPC.getPath('home')
    defaultDirectories.documents = await ElectronIPC.getPath('documents')
    defaultDirectories.downloads = await ElectronIPC.getPath('downloads')

    if (env.OS === 'win32') {
        defaultDirectories.remote_recording = `${defaultDirectories.documents}\\Muse\\Audio Recordings`
        defaultDirectories.screen_recording = `${defaultDirectories.documents}\\Muse\\Screen Recordings`
    } else {
        defaultDirectories.remote_recording = `${defaultDirectories.documents}/Muse/Audio Recordings`
        defaultDirectories.screen_recording = `${defaultDirectories.documents}/Muse/Screen Recordings`
    }

    console.log(`init: loaded defaultDirectories=` + JSON.stringify(defaultDirectories))
}

// Runtime constants
interface RuntimeConstants_Links {
    about_local_loopback: string
    troubleshoot_no_external_audio_input_devices: string
    troubleshoot_no_system_audio_input_devices: string
    troubleshoot_cant_find_my_audio_device: string
    troubleshoot_video_error: string
    troubleshoot_desktop_error: string
    about_local_loopback_output_device_mismatch_mac: string
    about_midi_mac: string
    about_midi_windows: string
    about_remote_recording: string
    app_download_link_darwin: string
    app_download_link_darwin_arm64: string
    app_download_link_win32: string
    website_index: string
    webapp_index: string
    website_faq: string
    website_tutorials: string
    zendesk_tutorials: string
    website_bugreports: string
    website_login: string
    website_join: string
    website_download_center: string
    muse_static_resources_path: string
    inapptutorial_v1_darwin_share_daw_audio: string
    inapptutorial_v1_darwin_share_daw_audio_without_latency: string
    inapptutorial_v1_darwin_share_computer_audio: string
    inapptutorial_v1_win32_share_daw_audio: string
    inapptutorial_v1_win32_share_computer_audio: string
    muse_pro_guide: string
    docs_host: string
    discord_invite_link: string
    muse_pro_plans_link: string
    about_boosts_link: string
    sfu_ws_url: string
    survey_link: string
    signup_link: string
    vb_audio_cable_download_link: string
    feature_waitlist_form: string
}
export let links: RuntimeConstants_Links = {
    about_local_loopback: '#',
    troubleshoot_no_external_audio_input_devices: '#',
    troubleshoot_no_system_audio_input_devices: '#',
    troubleshoot_cant_find_my_audio_device: '#',
    troubleshoot_video_error: '#',
    troubleshoot_desktop_error: '#',
    about_local_loopback_output_device_mismatch_mac: '#',
    about_midi_mac: '#',
    about_midi_windows: '#',
    about_remote_recording: '#',
    app_download_link_darwin: '#',
    app_download_link_darwin_arm64: '#',
    app_download_link_win32: '#',
    website_index: '#',
    webapp_index: 'https://app.musesessions.co',
    website_faq: '#',
    website_tutorials: '#',
    zendesk_tutorials: '#',
    website_bugreports: '#',
    website_login: '#',
    website_join: '#',
    website_download_center: 'https://musesessions.co/download-center',
    muse_static_resources_path: 'musecdn.sfo3.digitaloceanspaces.com/muse-site',
    inapptutorial_v1_darwin_share_daw_audio: '#',
    inapptutorial_v1_darwin_share_daw_audio_without_latency: '#',
    inapptutorial_v1_darwin_share_computer_audio: '#',
    inapptutorial_v1_win32_share_daw_audio: '#',
    inapptutorial_v1_win32_share_computer_audio: '#',
    muse_pro_guide: 'https://docs.google.com/document/d/1cy8YlG5o9Z9qrNZ9mCzATWxIhXEIzq-VQEfyk2cJt0U/',
    docs_host: 'http://docs.musecore.net',
    discord_invite_link: 'https://discord.gg/DgyYafBQDV',
    muse_pro_plans_link: '#',
    about_boosts_link: '#',
    // used as the fallback since 1.5.10; sfu servers are chosen by
    // nearest ping since 1.5.10.
    sfu_ws_url: 'wss://livekit-sfo3-01.musecore.net',
    survey_link: '#',
    signup_link: 'https://www.musesessions.co/sign-up',
    vb_audio_cable_download_link: 'https://vb-audio.com/Cable/index.htm',
    feature_waitlist_form: 'https://p4ckdtcnl96.typeform.com/to/PDoi8LNa#email={email}',
}

interface InappTutorialIndexItem {
    title: string
    url: string
}

export type RuntimeConstants_BackgroundImage = {
    id: string
    image: string
    thumb: string
    name: string
}

interface RuntimeConstants_Data {
    inapptutorial_v2_listing: {
        darwin: InappTutorialIndexItem[]
        win32: InappTutorialIndexItem[]
    }

    collaboratepage_quick_setup_guide: {
        darwin: { video_url: string; caption: string }
        win32: { video_url: string; caption: string }
    }

    convert_to_sfu_error_threshold: number
    p2p_connection_timeout_ms: number
    ice_servers: { url: string; username: string; credential: string }[]
    relay_nodes: AudioEngineRelayServer[]
    disable_livekit_explicit_visibility_changed_handler: boolean
    node_latency_measurement_timeout_ms: number
    audioengine_dropped_audio_warning_pct_threshold: number
    virtual_backgrounds: RuntimeConstants_BackgroundImage[]
    gallery_min_video_width_screen_factor: number
    gallery_min_video_width_min: number
    gallery_min_video_width_max: number
    max_audio_subscription_users: number
    max_video_subscription_users: number
    sentry_event_drop_list: string[]
}
export let data: RuntimeConstants_Data = {
    inapptutorial_v2_listing: {
        darwin: [],
        win32: [],
    },

    collaboratepage_quick_setup_guide: {
        darwin: { video_url: '', caption: '' },
        win32: { video_url: '', caption: '' },
    },

    // how many SimplePeer errors before converting to sfu -- used MuseP2pPeerManagement.
    convert_to_sfu_error_threshold: 2,

    // initial p2p connection hard timeout
    p2p_connection_timeout_ms: 5500,

    audioengine_dropped_audio_warning_pct_threshold: 10,

    // from v1.5.10, uses this ice_servers list instead of using the one given
    // by muse-ws in join-room result. the previous ice servers list was expanded
    // in-app to include TURN servers; since from v1.5.10, we are not using the
    // TURN servers, this `ice_servers` list will only include the STUN servers.
    ice_servers: [],

    relay_nodes: [],

    disable_livekit_explicit_visibility_changed_handler: false,

    node_latency_measurement_timeout_ms: 2000,

    virtual_backgrounds: [],

    gallery_min_video_width_screen_factor: 6,
    gallery_min_video_width_min: 80,
    gallery_min_video_width_max: 360,
    max_audio_subscription_users: 30,
    max_video_subscription_users: 50,

    sentry_event_drop_list: [],
}

type RuntimeConstants_AppstartNotification = {
    isActive: boolean
    id: number
    md: string
    html: string
}

type VersionedAppLink = {
    version_range: string
    app_url: string
    default?: boolean
}

interface RuntimeConstants {
    app_latest_version: string
    support_email: string
    links: RuntimeConstants_Links
    data: RuntimeConstants_Data
    appstart_notification: RuntimeConstants_AppstartNotification
    virtual_backgrounds: RuntimeConstants_BackgroundImage[]
    app_links: VersionedAppLink[]
}

export let app_latest_version = ''
export let support_email = ''
export let appstart_notification: RuntimeConstants_AppstartNotification = { isActive: false, id: 0, md: '', html: '' }
export let virtual_backgrounds: RuntimeConstants_BackgroundImage[] = []
export let app_links: VersionedAppLink[] = []

export function loadRuntimeConstants(source: RuntimeConstants) {
    links = copyObjectByKeyOnto(links, source.links)
    // Override some fields in `links` with env vars.
    if (env.DOCS_HOST) {
        links.docs_host = env.DOCS_HOST
    }

    data = copyObjectByKeyOnto(data, source.data)

    app_latest_version = source.app_latest_version
    support_email = source.support_email
    appstart_notification = source.appstart_notification
    virtual_backgrounds = source.virtual_backgrounds
    app_links = source.app_links

    console.log('loadRuntimeConstants: data=%O', data)
}
